import {useTranslation} from 'react-i18next'
import {buttonVariants} from '@/components/ui/button'
import {ExternalLinkGlyph} from '@/components/ui/icons'
import {cn} from '@/lib/utils'
import type {TarjetaCola} from '@/lib/bateria-cola'

/** Enlaces a la hoja y al cuadernillo, siempre que el servidor los mande, para confirmar contra el papel. */
export function VerElPapel({tarjeta, testIdPrefix}: {tarjeta: TarjetaCola; testIdPrefix: string}) {
  const {t} = useTranslation()
  const enlaces = [
    tarjeta.pagina_pdf_url && {
      // La rebanada ya es una sola hoja: `#page=` nombraría una página que no tiene.
      url: tarjeta.pagina_pdf_url,
      testId: `${testIdPrefix}-ver-pagina`,
      texto: t('admin.bateria.cola.papel.pagina', {numero: tarjeta.pagina_numero ?? ''}),
    },
    tarjeta.paquete_pdf_url && {
      url: enHoja(tarjeta.paquete_pdf_url, tarjeta.pagina_numero),
      testId: `${testIdPrefix}-ver-cuadernillo`,
      texto: tarjeta.pagina_numero
        ? t('admin.bateria.cola.papel.cuadernilloEnPagina', {numero: tarjeta.pagina_numero})
        : t('admin.bateria.cola.papel.cuadernillo'),
    },
  ].filter((enlace) => enlace !== null && enlace !== undefined && enlace !== '')
  if (enlaces.length === 0) return null
  return (
    <div className="flex flex-wrap items-center gap-2">
      {enlaces.map((enlace) => (
        <a
          key={enlace.testId}
          href={enlace.url}
          target="_blank"
          rel="noreferrer"
          data-testid={enlace.testId}
          className={cn(buttonVariants({variant: 'outline', size: 'sm'}), 'min-h-11 md:min-h-0')}>
          <ExternalLinkGlyph />
          {enlace.texto}
        </a>
      ))}
    </div>
  )
}

/** `#page=N` lo respetan los visores de PDF y, como fragmento, no entra en la firma de GCS. */
function enHoja(url: string, numero: number | null | undefined): string {
  return numero ? `${url}#page=${numero}` : url
}
